import $ from 'jquery';
import noop from 'lodash/noop';

import { uploadAndProcessFile } from 'zoomforth_zfutils/asset_precursor_file_uploader.js';
import { toTileAspectRatioString } from 'zoomforth_codesbane_viewer/lib/aspect_ratios.js';
import { legacyCropDataToZfImage } from 'zoomforth_codesbane_editor/exterior_editor/editor_modals/image_cropper/transformers.js';
import { getZfImageForAsset } from 'zoomforth_media_library/lib/assets.js';
import { 
  ZF_JSON_OBJECT_TYPE_PROPERTY, 
  ZF_JSON_IMAGE_TYPE,
} from 'const_shared.js';

export const getDisplayableAssetType = (asset)=> {
  if (!asset) {
    return '';
  }

  switch (asset.assetType) {

  case 'video':
    return 'Video';

  case 'photo':
    return 'Image';

  case 'youtube':
    return 'YouTube';

  case 'pdf':
    return 'PDF';

  case 'ppt':
    return 'Presentation';

  case 'html_package':
    return 'HTML Package';

  case 'form':
    return 'Form';

  case 'other':
    return 'Downloadable File';

  default:
    throw new Error(`Unexpected asset type; ${asset.assetType}`);

  }
};

export const shouldUseNameAndCaptionForDefaults = (asset)=>
  !!asset.use_default_title;

export const getAssetZfImage = (asset, { sizex, sizey }) => {
  const cachedZfImage = getCachedCroppedZfImageFromAsset(asset, { sizex, sizey });
  
  if(cachedZfImage){
    return cachedZfImage;
  }

  return getZfImageForAsset(asset);
};

export const getCachedCroppedZfImageFromAsset = (asset, { sizex, sizey })=> {
  const aspectRatio = toTileAspectRatioString({ sizex, sizey });
  
  if (
    asset &&
    asset.displayImage && 
    asset.cachedCrops && 
    asset.cachedCrops[aspectRatio]
  ){
    var cachedZfImageCrop = asset.cachedCrops[aspectRatio];;
    
    if(!cachedZfImageCrop){
      return null;
    }
    
    if(cachedZfImageCrop[ZF_JSON_OBJECT_TYPE_PROPERTY] !== ZF_JSON_IMAGE_TYPE){
      cachedZfImageCrop = legacyCropDataToZfImage({ 
        legacyCropData: cachedZfImageCrop,
        legacyImageSrc: asset.displayImage // We never cached uncompressed crops before the new cropper
      });
    }

    return cachedZfImageCrop;
  }

  return null;
};

export const uploadFileAndFetchAsset = (file, { uploadContext, forceAssetType, onBeginProcessing=noop, onProgressChange, onAssetReceive, onError })=> {
  const fetchAsset = ({ assetId, assetType})=> {
    return $.get(`/api/assets/${assetType}-${assetId}`);
  };
  
  uploadAndProcessFile(
    file,
    {
      onUploadProgress: (precursor, e, percent)=> {
        onProgressChange({ isUploading: true, percent });
      },
      onUploadFailure: onError,
      onBeginProcessing: ()=> {
        onBeginProcessing();
        onProgressChange({ isProcessing: true, isUploading: false, percent: null });
      },
      onProcessingError: onError,
      onProcessingSuccess: (precursor)=> {
        onProgressChange({ isFetching: true, isProcessing: false });
        fetchAsset(precursor)
          .done((asset) => {
            onProgressChange({ isFetching: false });
            onAssetReceive(asset);
          })
          .fail(onError);
      }

    },
    {
      just_uploaded_from: uploadContext || 'page',
      force_asset_type: forceAssetType
    }
  );

};

export const getCroppableImageUrlFromAsset = (asset)=> {
  return asset.displayImage || asset.originalImage;
};
